const pageNameKey = "vncCountdownBar";

export const vncCountdownBarEn = {
  [pageNameKey]: {
    sessionStatusTextActive: "Active",
    sessionStatusTextCompleted: "Completed",
  },
};

export const vncCountdownBarPtBr = {
  [pageNameKey]: {
    sessionStatusTextActive: "Ativo",
    sessionStatusTextCompleted: "Concluído",
  },
};

export const vncCountdownBarDe = {
  [pageNameKey]: {
    sessionStatusTextActive: "Aktiv",
    sessionStatusTextCompleted: "Abgeschlossen",
  },
};

export const vncCountdownBarZhHans = {
  [pageNameKey]: {
    sessionStatusTextActive: "活动",
    sessionStatusTextCompleted: "已完成",
  },
};

export const vncCountdownBarIt = {
  [pageNameKey]: {
    sessionStatusTextActive: "Attivo",
    sessionStatusTextCompleted: "Completato",
  },
};

export const vncCountdownBarEs = {
  [pageNameKey]: {
    sessionStatusTextActive: "Activo",
    sessionStatusTextCompleted: "Completado",
  },
};

export const vncCountdownBarNl = {
  [pageNameKey]: {
    sessionStatusTextActive: "Actief",
    sessionStatusTextCompleted: "Voltooid",
  },
};

export const vncCountdownBarTr = {
  [pageNameKey]: {
    sessionStatusTextActive: "Aktif",
    sessionStatusTextCompleted: "Tamamlanmış",
  },
};
